import React, { useEffect, useRef } from 'react';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import { checkBrowser } from '../../common/utils/utils';
import Image from 'next/image';

const Status = ({ status, idx, compStyles }) => {
    const width = useWindowDimensions();
    const ref = useRef();
    useEffect(() => {
        const textElement = ref.current;
        if (!textElement) return;

        const parentElement = textElement.parentElement;
        let fontSize = 40; // Початковий розмір шрифту в пікселях

        textElement.style.fontSize = fontSize + 'px';
        const parentElementPos = parentElement.getBoundingClientRect();
        // Зменшуємо розмір шрифту, поки текст не поміститься в блок
        while (
            checkBrowser(textElement.scrollWidth) > checkBrowser(parentElementPos.width) * 0.8 ||
            checkBrowser(textElement.scrollHeight) > checkBrowser(parentElementPos.height) * 0.8
        ) {
            fontSize -= 1;
            textElement.style.fontSize = fontSize + 'px';
            textElement.style.transform = 'translate(-50%, -50%)';
            textElement.style.top = '50%';
            textElement.style.left = '50%';
            if (parentElement.getBoundingClientRect().x <= 0) {
                parentElement.style.transform = `translate(-${idx * 32}%, ${idx * 45}%)`;
                parentElement.style.marginLeft = `${-parentElement.getBoundingClientRect().x}px`;
            } else {
                parentElement.style.transform = `translate(-${idx * 32}%, ${idx * 45}%)`;
            }
        }
    }, [status, idx, width]);

    return (
        <div style={{ zIndex: idx + 1 }} className={compStyles?.specialStatusItem}>
            <Image fill src={`/src/img/productStatuses/product-status-${status.type}.svg`} alt={`Status ${status.type}`} />
            <p ref={ref}>{status.name}</p>
        </div>
    );
};

const SpecialStatus = ({ statuses, compStyles, type }) => {
    return (
        <div className={type === 'slider' ? compStyles.statusBlock : compStyles.statusBlockGrid}>
            {statuses?.length
                ? statuses.map((elem, idx) => {
                      return <Status key={elem.id} status={elem} idx={idx} compStyles={compStyles} />;
                  })
                : null}
        </div>
    );
};
export default SpecialStatus;
